import React, { useMemo } from 'react'
import { Tooltip } from 'antd'

interface Country {
  id?: number
  code?: string
  name?: string
}

interface Props {
  countries?: Country[]
  max: number
}

const CountryList = ({ countries, max }: Props) => {
  if (!countries?.length) {
    return null
  }

  const { shownCountries, extraCount, tooltipTitle } = useMemo(() => {
    const shownCountries = countries.slice(0, max)
    const extraCount = countries.length - max
    const tooltipTitle = countries.map((c) => c.name).join(', ')
    return { shownCountries, extraCount, tooltipTitle }
  }, [countries, max])

  return (
    <div className='flex items-center'>
      {shownCountries.map(({ code, name }) => (
        <Tooltip key={code} title={name}>
          <div className='relative mr-[-8px] h-[30px] w-[30px] overflow-hidden rounded-full border-2 border-aqua/[.1]'>
            <span className={`fi fis fi-${code} absolute top-0 left-0 block !h-[26px] !w-[26px]`} />
          </div>
        </Tooltip>
      ))}
      {extraCount > 0 && (
        <Tooltip title={tooltipTitle}>
          <div className='relative mr-[-8px] h-[30px] w-[30px] overflow-hidden rounded-full border-2 border-white'>
            <span className='absolute top-0 left-0 flex h-full w-full cursor-default items-center justify-center bg-grey-300 text-[12px] font-medium'>
              +{extraCount}
            </span>
          </div>
        </Tooltip>
      )}
    </div>
  )
}

export default CountryList
